import { css } from '@emotion/css'
import getThemeColors, { colors } from '../../themes'
import { shorthandHelper } from '../../styles/helpers'
import { spacing, fontFamily, fontWeight, fontSize, borderRadius } from '../../styles'

const styles = {
  chip: css({
    display: 'inline-flex',
    alignItems: 'center',
    fontFamily: fontFamily.body,
    fontWeight: fontWeight.bold,
    lineHeight: 1.2,
    whiteSpace: 'nowrap',
    borderRadius: borderRadius.extraLarge,
    padding: shorthandHelper([0, spacing.default]),
  }),
}

export default styles

export const chipTheme = (theme, mode) => {
  const themed = getThemeColors(theme)

  switch (mode) {
    case 'dark':
      return css({
        backgroundColor: themed.base,
        color: colors.white,
      })

    default:
      return css({
        backgroundColor: themed.light,
        color: theme === 'light' ? colors.jumbo : themed.base,
      })
  }
}

export const chipSize = size => {
  switch (size) {
    case 'small':
      return css({
        height: 20,
        maxHeight: 20,
        fontSize: fontSize.extraSmall,
      })

    default:
      return css({
        height: 26,
        maxHeight: 26,
        fontSize: fontSize.small,
      })
  }
}
